@for (prop of growlProp; track prop; let i = $index) {
  <div data-cy="tasc-growler">
    @if (prop.growelVisibility) {
      <div
        class="tasc-growl"
        id="tasc-growl-id"
        [ngClass]="{
          'tasc-warning': prop.type === 'warning',
          'tasc-error': prop.type === false,
          'tasc-success': prop.type === true || prop.type === 'covid-link',
        }"
      >
        <span [innerHTML]="prop.message" appRouteTransform></span>
        @if (prop.link) {
          <span class="undo-link"><a [routerLink]="[prop.link]">Posting Summary</a></span>
        }
        @if (prop.undo) {
          <span class="undo-link"><a (click)="undoChanges()" tabindex="0" role="button" (keyup.enter)="$event.target.click()">Undo</a></span>
        }
        @if (prop.postManuallyLink) {
          <span class="post-manually-link"><a (click)="postNow()" tabindex="0" role="button" (keyup.enter)="$event.target.click()">POST NOW</a></span>
        }
        @if (!prop.type || prop.type === 'warning' || prop.type === 'covid-link') {
          <span class="close-growl" id="close-growl-id" title="close" (click)="closeGrowel(i)" tabindex="0" role="button" data-cy="close-growler" (keyup.enter)="$event.target.click()"></span>
        }
      </div>
    }
  </div>
}
